export const primaryDetailsOrder = [
  "id",
  "company",
  "model",
  "year_of_manufacturing",
];

export const unitMap = {
  face_plate_diameter: "mm",
  turning_diameter: "mm",
  height: "mm",
  ram_travel: "mm",
  ram_size: "mm",
  working_feed_range: "mm/rev",
  main_motor_power: "kW",
  gearbox_steps: "steps",
  max_workpiece_weight: "kg",
  dimensions: "mm",
  weight: "kg",
  chuck_size: "mm",
  machining_diameter: "mm",
  machining_length: "mm",
  spindle_bore_diameter: "mm",
  max_spindle_speed: "RPM",
  table_dimensions: "mm",
  number_of_axes: "qty",
  number_of_tools: "qty",
  "x-axis-travel": "mm",
  "y-axis-travel": "mm",
  "z-axis-travel": "mm",
  "w-axis-travel": "mm",
};

export const technicalInformationRows = [
  // "custom:product_name",
  // "machine_type",
  // "company",
  // "model",
  // "year_of_manufacturing",
  // "made_in",
  // "controller_model",
  // "face_plate_diameter",
  // "turning_diameter",
  // "height",
  // "ram_travel",
  // "ram_size",
  // "working_feed_range",
  // "main_motor_power",
  // "gearbox_steps",
  // "max_workpiece_weight",
  // "custom:dimensions",
  // "weight",

  "custom:product_name",
  "machine_type",
  "made_in",
  "controller_model",
  "chip_conveyor",
  "turret_type",
  "number_of_turret_tools",
  "turret_engine_type",
  "tailstock",
  "lunette",
  "chuck_size",
  "turning_diameter",
  "machining_diameter",
  "machining_length",
  "spindle_type",
  "spindle_bore_type",
  "spindle_bore_diameter",
  "max_spindle_speed",
  "x-axis-travel",
  "y-axis-travel",
  "z-axis-travel",
  "table_dimensions",
  "weight",
  "supplementary_details",
];

export const productDataMap = {
  id: {
    title: "MT-ID",
    translationFa: "شناسه",
  },
  post_title: {
    title: "Device Name",
    translationFa: "نام دستگاه",
  },
  company: {
    title: "Manufacturer",
    translationFa: "شرکت سازنده",
  },
  machine_type: {
    title: "Machine Type",
    translationFa: "تیپ",
  },
  model: {
    title: "Model",
    translationFa: "مدل",
  },
  year_of_manufacturing: {
    title: "Manufacture Year",
    translationFa: "سال ساخت",
  },
  made_in: {
    title: "Country of Manufacture",
    translationFa: "کشور سازنده",
  },
  controller: {
    title: "Controller",
    translationFa: "کنترلر",
  },
  controller_model: {
    title: "Controller Model",
    translationFa: "مدل کنترلر",
  },
  chip_conveyor: {
    title: "Chip Conveyor",
    translationFa: "سفاله کش",
  },
  turret_type: {
    title: "Turret Type",
    translationFa: "نوع تارت",
  },
  number_of_turret_tools: {
    title: "Number of Turret Tools",
    translationFa: "تعداد ابزار تارت",
  },
  turret_engine_type: {
    title: "Turret Engine Type",
    translationFa: "نوع موتور تارت",
  },
  tailstock: {
    title: "Tailstock",
    translationFa: "مرغک",
  },
  lunette: {
    title: "Lunette",
    translationFa: "لینت",
  },
  chuck_size: {
    title: "Chuck Size",
    translationFa: "قطر سه نظام",
  },
  machining_diameter: {
    title: "Machining Diameter",
    translationFa: "قطر ماشین کاری",
  },
  turning_diameter: {
    title: "Turning Diameter",
    translationFa: "قطر قابل گردش",
  },
  machining_length: {
    title: "Machining Length",
    translationFa: "طول قابل تراشکاری",
  },
  have_c_axis: {
    title: "C Axis",
    translationFa: "محور c",
  },
  have_y_axis: {
    title: "Y Axis",
    translationFa: "محور y",
  },
  spindle_bore_type: {
    title: "Spindle Bore Type",
    translationFa: "گلو اسپیندل",
  },
  spindle_bore_diameter: {
    title: "Spindle Bore Diameter",
    translationFa: "قطر گلویی",
  },
  spindle_type: {
    title: "Spindle Type",
    translationFa: "نوع اسپیندل",
  },
  max_spindle_speed: {
    title: "Max Spindle Speed",
    translationFa: "حداکثر دور اسپیندل",
  },
  table_dimensions: {
    title: "Table Dimensions",
    translationFa: "ابعاد میز",
  },
  number_of_axes: {
    title: "Number of Axes",
    translationFa: "تعداد محور",
  },
  tool_changer_type: {
    title: "Tool Changer Type",
    translationFa: "نوع تول چنجر",
  },
  number_of_tools: {
    title: "Number of Tools",
    translationFa: "تعداد ابزار",
  },
  tool_std: {
    title: "Tool Standard",
    translationFa: "استاندارد ابزار",
  },
  tool_size: {
    title: "Tool Size",
    translationFa: "اندازه ابزار",
  },
  axes_mechanism: {
    title: "Axes Mechanism",
    translationFa: "مکانیزم محوره",
  },
  "x-axis-travel": {
    title: "X Axis Travel",
    translationFa: "کورس محور X",
  },
  "y-axis-travel": {
    title: "Y Axis Travel",
    translationFa: "کورس محور Y",
  },
  "z-axis-travel": {
    title: "Z Axis Travel",
    translationFa: "کورس محور Z",
  },
  "w-axis-travel": {
    title: "W Axis Travel",
    translationFa: "کورس محور W",
  },
  supplementary_details: {
    title: "Additional Details",
    translationFa: "توضیحات تکمیلی",
  },
  weight: {
    title: "Weight",
    translationFa: "وزن",
  },
  // missing keys from api
  face_plate_diameter: {
    title: "Face Plate Diameter",
    translationFa: "قطر صفحه نظام",
  },
  height: {
    title: "Height",
    translationFa: "ارتفاع",
  },
  ram_travel: {
    title: "Ram Travel",
    translationFa: "کورس رام",
  },
  ram_size: {
    title: "Ram Size",
    translationFa: "سایز رام",
  },
  working_feed_range: {
    title: "Working Feed Range",
    translationFa: "محدوده پیشروی",
  },
  main_motor_power: {
    title: "Main Motor Power",
    translationFa: "قدرت موتور اصلی",
  },
  gearbox_steps: {
    title: "Gearbox Steps",
    translationFa: "تعداد دنده گیربکس",
  },
  max_workpiece_weight: {
    title: "Max Workpiece Weight",
    translationFa: "حداکثر وزن قطعه کار",
  },
  dimensions: {
    title: "Dimensions",
    translationFa: "ابعاد",
  },
} as const;

export const handleRenderImageSrc = (imagesArray, numberInOrder) => {
  const imagesArrayAlt =
    imagesArray && imagesArray.length
      ? imagesArray
      : [
          {
            src: "https://panel.armancnc.com/wp-content/smush-webp/woocommerce-placeholder-600x600.png.webp",
          },
          {
            src: "https://panel.armancnc.com/wp-content/smush-webp/woocommerce-placeholder-600x600.png.webp",
          },
        ];

  const imageData = imagesArrayAlt[numberInOrder - 1];

  return (
    imageData && (
      <img src={imageData.src} alt="catalogue" className="catalogue-img" />
    )
  );
};
